import { isDefined } from "@utils/var.check";
import { COMMENT_RESOURCE_TYPE } from "@plugins/comment/comment.constant";
import i18n from "@plugins/i18n.ts";

export default class CommentProps {
  constructor(params) {
    const defaultPagination = 5;

    if (params) {
      this.uuid = params.uuid;
      this.editable = params.editable;
      this.deletable = isDefined(params.deletable) ? params.deletable : true;
      this.resourceUuid = params.resourceUuid;
      this.academicYear = params.academicYear;
      this.resourceId = params.resourceId;
      this.autoFocus = params.autoFocus;
      this.allowNotify = isDefined(params.allowNotify) ? params.allowNotify : false;
      this.allowCreate = isDefined(params.allowCreate) ? params.allowCreate : true;
      this.readOnly = isDefined(params.readOnly) ? params.readOnly : false;
      this.canInitiate = isDefined(params.canInitiate) ? params.canInitiate : true;
      this.allowComment = isDefined(params.allowComment) ? params.allowComment : true;
      this.showComment = isDefined(params.showComment) ? params.showComment : true;
      this.freezeInteraction = params.freezeInteraction;
      this.resourceType = this.checkResourceType(params.resourceType) ? params.resourceType : "";
      this.pageSize = isDefined(params.pageSize) ? params.pageSize : defaultPagination;
      this.addButtonLabel = isDefined(params.addButtonLabel)
        ? params.addButtonLabel
        : i18n.t("button_add");
      this.tinyMceType = isDefined(params.tinyMceType)
        ? params.tinyMceType
        : "student_teacher_tinymce_2";
      this.loadPreviousLabel = isDefined(params.loadPreviousLabel)
        ? params.loadPreviousLabel
        : i18n.t("previous_comment_label");
      this.commentButtonKind = isDefined(params.commentButtonKind)
        ? params.commentButtonKind
        : "primary";
      this.textSize = isDefined(params.textSize) ? params.textSize : "small";
      this.commentIcon = isDefined(params.commentIcon) ? params.commentIcon : "CommentAdd32";
      this.noCommentLabel = isDefined(params.noCommentLabel)
        ? params.noCommentLabel
        : i18n.t("no_comment_label");
      this.emptyCommentPlaceholder = isDefined(params.emptyCommentPlaceholder)
        ? params.emptyCommentPlaceholder
        : true;
      this.ownerRestricted = isDefined(params.ownerRestricted) //if not ownerRestricted then its can be edit/deleted by other teachers
        ? params.ownerRestricted
        : false;
      this.numberOfComments = params.numberOfComments;
      this.isTeacherStudentView = params.isTeacherStudentView;
      this.fromDiscussion = params.fromDiscussion;
      this.teamId = params.teamId;
      this.visibleByStudents = isDefined(params.visibleByStudents)
        ? params.visibleByStudents
        : false;
      this.isAnchorToLastComment = params.isAnchorToLastComment;
      this.isFeedback = params.isFeedback;
    }
  }

  checkResourceType(resourceType) {
    return (
      resourceType === COMMENT_RESOURCE_TYPE.ANNOTATION ||
      resourceType === COMMENT_RESOURCE_TYPE.POST ||
      resourceType === COMMENT_RESOURCE_TYPE.QUESTION_ANSWER ||
      resourceType === COMMENT_RESOURCE_TYPE.ATTEMPT_HISTORY ||
      resourceType === COMMENT_RESOURCE_TYPE.TEAM_ATTEMPT_HISTORY ||
      resourceType === COMMENT_RESOURCE_TYPE.QUESTION ||
      resourceType === COMMENT_RESOURCE_TYPE.ACTIVITY_QUIZ
    );
  }
}
